import type { ElementDefinition } from './types';
import type { TemplateProfile } from '../templates';
import { insertExhibit } from '../word/exhibit';

/** Element definition for full-width exhibit insertion. */
export const fullExhibitElement: ElementDefinition = {
  id: 'full-exhibit',
  label: 'Graph Full',
  icon: 'SplitHorizontalRegular',
  description: 'Full width graph exhibit',
  category: 'exhibit',
  async insertAsync(profile: TemplateProfile): Promise<void> {
    await insertExhibit('full', profile);
  },
};

/** Toolbar action for full-width exhibit insertion. */
export async function insertGraphFullLayout(profile: TemplateProfile): Promise<void> {
  await insertExhibit('full', profile);
}
